
function NewOrder() {
    return (
        <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">&nbsp;</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                    </div>
                    <form class="tablelist-form" autocomplete="off">
                        <div class="modal-body">
                            <input id="id-field" type="hidden" />
                            <div class="row gy-4 mb-3">
                                
                                <div class="col-md-12">
                                    <div >
                                        <label for="customername-field" class="form-label">Patient Name</label>
                                        <input id="customername-field" class="form-control" placeholder="Enter name" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="productname-field" class="form-label">Medicine</label>
                                        <select class="form-control" data-trigger="" name="productname-field" id="productname-field">
                                            <option value="">Med 1</option>
                                            <option value="">Med 2</option>
                                            <option value="">Med 3</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="customername-field" class="form-label">Qty</label>
                                        <input id="customername-field" class="form-control" placeholder="Enter Qty" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="productname-field" class="form-label">Status</label>
                                        <select class="form-control" data-trigger="" name="productname-field" id="productname-field">
                                            <option value="">Sales</option>
                                            <option value="">Sales Return</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-success" id="edit-btn">Add</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default NewOrder;
